<template>
   <div>
     <vuestic-widget :header-text="'Crear Orden de Compra'">
        <form action="" id="crearOrdenCompra" method="get">
          <div class="ui-grid va-row">
            <div class="flex xs12 md12">
              <div class="va-row">
                <div class="flex xs6">
                  <label for="rutProveedor">Rut Proveedor</label>
                  <input class="required" name="rutProveedor" id="rutProveedor" type="text">
                  <label for="nombreProveedor">Nombre Proveedor</label>
                  <input type="text" id="nombreProveedor">
                  <label for="atencion_a">Atención A</label>
                  <input class="atencion" id="atencion_a" type="text">
                  <label for="fecha">Fecha</label>
                  <input id="fecha" type="date">
                  <label for="fechaRecepcion">Fecha Recepción</label>
                  <input id="fechaRecepcion" type="date">
                </div>
                <div class="selects flex xs6">
                  <tipo/>
                  <br>
                  <br>
                  <condicion-pago/>
                  <br>
                  <br>
                  <transporte/>
                </div>
              </div>
              <div class="flex xs12 md12">
              </div>
            </div>
          </div>
        </form>
        <tabla-detalle-crear/>
        <tabla-pie/>
        <btn-crear/>
     </vuestic-widget>
  </div>
</template>
<script>
    import InputComponent from "../../../input/InputComponent";
    import VuesticCard from "../../../../vuestic-theme/vuestic-components/vuestic-card/VuesticCard";
    import VuesticWidget from "../../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
    import Tipo from "../selectCompras/Tipo";
    import CondicionPago from "../selectCompras/CondicionPago";
    import Transporte from "../selectCompras/Transporte";
    import TablaDetalleCrear from "../Tablas/tablaDetalleCrear";
    import BtnCrear from "../BtnCompra/btnCrear";
    import TablaPie from "../Tablas/tablaPie";
    export default {
        name: "crearOrdenDeCompra",
        data(){
            return{
                show: true,
                rutProveedor:[],
                nombreProveedor:'',
                tipo:''
            }
        },
        components: {
          TablaPie,
          BtnCrear,
          TablaDetalleCrear,
          Transporte,
          CondicionPago,
          Tipo,
          VuesticWidget,
          VuesticCard,
          InputComponent
        },
    }
</script>

<style scoped>
    button:hover{
        background-color: #8bff76;
        color: white;
    }
    button{
        color: white;
        background: #49ff60 ;
        border:2px solid;
        font-size: 20px;
        width: 15em;
        height: 50px;
        border-radius: 20px;
        box-shadow: 0 3px 3px;

    }
    input{
        width: 14em;
        margin-top: 20px;
        margin:10px;

    }
    .atencion{
        width: 88%;
    }
    label{
        display: block;
        margin-left: 10px;
        margin-bottom: 0px;
        font-weight: bold;
    }


</style>
